import {
  clearFilterDropdownOptions,
  disableFilterDropdownOption,
  enableFilterDropdownOption,
  updateFilterDropdownOptionTotalMatching
} from "../FilterDropdown/filter-dropdown";
import { firstCharToLower, isNullOrWhiteSpace } from "./string";

export type FilterFacet = {
  name: string;
  selected: boolean;
  totalMatching?: number;
  value: string;
};

export type FilterFacetCollection = {
  label: string;
  name: string;
  options: FilterFacet[];
};

/**
 * Updates the form's filter dropdown options with new filter facet data from Opti.
 * @param form
 * @param filterFacetCollections
 */
export const updateFormFilterFacets = (
  form: HTMLElement,
  jsonElement?: HTMLElement | null
) => {
  const updatedFilterFacetsJson =
    jsonElement?.textContent ??
    form.querySelector<HTMLElement>("[data-facets-json]")?.textContent;

  const updatedFilterFacetCollections = !isNullOrWhiteSpace(updatedFilterFacetsJson)
    ? (JSON.parse(updatedFilterFacetsJson) as FilterFacetCollection[])
    : undefined;

  if (updatedFilterFacetCollections?.length) {
    const filterDropdowns = Array.from(
      form.querySelectorAll<HTMLElement>("[data-filter-dropdown]")
    );

    for (const filterFacetCollection of updatedFilterFacetCollections) {
      for (const filterDropdown of filterDropdowns) {
        const select = filterDropdown.querySelector<HTMLSelectElement>(
          `[name="${firstCharToLower(filterFacetCollection.name)}"]`
        );

        if (select) {
          for (const selectOption of select.options) {
            const facetOption = filterFacetCollection.options.find(
              opt => opt.value === selectOption.value
            );

            if (facetOption) {
              enableFilterDropdownOption(filterDropdown, facetOption.value);

              if (facetOption.totalMatching !== undefined) {
                updateFilterDropdownOptionTotalMatching(
                  filterDropdown,
                  facetOption.value,
                  facetOption.totalMatching
                );
              }
            } else {
              if (selectOption.selected === false) {
                disableFilterDropdownOption(filterDropdown, selectOption.value);
              }
            }
          }

          break;
        }
      }
    }
  }
};

/**
 * [Re-]initializes the form's reset button, if any.
 * @param form
 */
export const refreshFormResetButton = (form: HTMLFormElement) => {
  const resetFiltersButton = form.querySelector<HTMLElement>("[data-reset-filters]");

  // Hook up the "reset filters" button, if it exists (it only shows up when the search returns empty)
  if (resetFiltersButton) {
    const searchInput = form.querySelector<HTMLInputElement>('[name="query"]');

    const filterDropdowns = Array.from(
      form.querySelectorAll<HTMLElement>("[data-filter-dropdown]")
    );

    resetFiltersButton.addEventListener("click", () => {
      if (searchInput) {
        searchInput.value = "";
      }

      for (const filterDropdown of filterDropdowns) {
        clearFilterDropdownOptions(filterDropdown);
      }

      form.requestSubmit();
    });
  }
};
